import { ReactElement } from 'react';

import GuideRow from '@/components/app/program/GuideRow';
import { GuideRowProps } from '@/components/app/program/GuideRow/types';
import MasterclassGuideRow from '@/components/app/program/MasterclassGuideRow';
import Loader from '@/components/Loader';
import useProgramStats from '@/hooks/app/useProgramStats';

import { Divider, Wrapper } from './styles';
import { GuideListProps } from './types';

const GuideRowComponent = ({ guide, program, programProgress }: GuideRowProps): ReactElement => {
	if (program && program.meditation_type === 'masterclass') {
		return <MasterclassGuideRow guide={guide} />;
	}

	return <GuideRow guide={guide} program={program} programProgress={programProgress} />;
};

const GuideList = ({ program }: GuideListProps): ReactElement => {
	const isMasterclass = program?.meditation_type === 'masterclass';

	const orderedGuides = program?.guides
		.filter(unOrdGuide => (isMasterclass ? !unOrdGuide.is_trailer : true))
		.sort((a, b) => (a.position > b.position ? 1 : -1));

	const { data: programProgress, isValidating: isLoading } = useProgramStats(program);

	if (isLoading) {
		return <Loader />;
	}

	return (
		<Wrapper role="list">
			<Divider isExtended={isMasterclass} />
			{orderedGuides &&
				orderedGuides.map(orderedGuide => (
					<GuideRowComponent
						key={orderedGuide.id}
						guide={orderedGuide}
						program={program}
						programProgress={programProgress ?? 0}
					/>
				))}
		</Wrapper>
	);
};

export default GuideList;
